export const getUrlCashClaimId = (cashClaimId) => {
  return cashClaimId ? `#${cashClaimId}` : "";
};
